import React from 'react';
import FormField from '../FormField';

export default function MeioAmbienteRecursosHidricos() {
  return (
    <div>
      <div className="mb-6 p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-700">Esta seção coleta informações sobre a situação atual do município quanto à gestão ambiental e aos recursos hídricos.</p>
      </div>

      <div className="mt-4">
        <FormField
          name="meio_ambiente_recursos_hidricos_situacao"
          label="Situação atual"
          type="textarea"
          placeholder="Descreva a situação atual do município quanto à gestão ambiental e aos recursos hídricos, considerando secretaria responsável, conselho, fundo, plano municipal, abastecimento, qualidade da água, proteção de nascentes e participação em comitês"
          helpText="Considere secretaria responsável, conselho, fundo, plano municipal, abastecimento, qualidade da água, proteção de nascentes e participação em comitês"
          rows={5}
          className="[&_.input]:min-h-[10rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="meio_ambiente_recursos_hidricos_indicadores"
          label="Principais indicadores"
          type="textarea"
          placeholder="Informe os principais indicadores encontrados, como áreas protegidas, APPs, licenças, infrações, cobertura de abastecimento, perdas, nascentes protegidas e volume captado, sempre com ano e unidade de referência"
          helpText="Áreas protegidas, APPs, licenças, infrações, cobertura de abastecimento, perdas, nascentes protegidas e volume captado, sempre com ano e unidade de referência"
          rows={5}
          className="[&_.input]:min-h-[10rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="meio_ambiente_recursos_hidricos_problemas"
          label="Principais problemas identificados"
          type="textarea"
          placeholder="Descreva os principais problemas identificados, considerando desmatamento, queimadas, assoreamento, contaminação, escassez, poluição e captação irregular"
          helpText="Considere desmatamento, queimadas, assoreamento, contaminação, escassez, poluição e captação irregular"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="meio_ambiente_recursos_hidricos_demandas"
          label="Demandas prioritárias identificadas"
          type="textarea"
          placeholder="Descreva as demandas prioritárias identificadas, considerando recuperação ambiental e de nascentes, fiscalização, monitoramento, educação ambiental, novos sistemas e apoio técnico"
          helpText="Considere recuperação ambiental e de nascentes, fiscalização, monitoramento, educação ambiental, novos sistemas e apoio técnico"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>

      <hr className="border-t border-gray-300 my-6" />
      <div className="mt-6 space-y-4">
        <FormField
          name="fontes_principais_secao2"
          label="Fontes principais"
          type="textarea"
          placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
          helpText=""
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />

        <FormField
          name="links_acesso_secao2"
          label="Links de acesso"
          type="textarea"
          placeholder="Insira os links para acesso às fontes"
          helpText="Informe URLs para acesso às fontes quando disponível"
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
      </div>
    </div>
  );
}
